<div *ngIf="isIrsAba" id="taxPaymentdetails">
  <span id="tax-payment-details-header">Tax payment details</span>
  <div class="row tax-details-row">
    <mm-text-input-control class="input-box" [parentForm]="parentForm" [hidden]="useSloa"
      [inputControlModel]="taxPayerId" data-testid="taxDetails_taxPayerId" [errorMessage]="taxPayerError || ''" (paste)="onPaste($event, 'taxPayerId')"></mm-text-input-control>
    <mm-text-input-control class="input-box" [parentForm]="parentForm" *ngIf="useSloa"
      [inputControlModel]="taxPayerIdMasked" data-testid="taxDetails_taxPayerIdMasked"></mm-text-input-control>
    <mm-text-input-control class="input-box" [parentForm]="parentForm"
      [inputControlModel]="taxTypeCode"  data-testid="taxDetails_taxTypeCode" [errorMessage]= "taxTypeCodeError || ''" (paste)="onPaste($event, 'taxTypeCode')"></mm-text-input-control>
    <mm-select-dropdown-control *ngIf="isFromCreateTransaction" class="irs-tax-dropdown" [parentForm]="parentForm" [selectModel]="taxYearDropDown" [isIrsDropdown]="true" id="taxDetails_taxYeardropdown"
      data-testid="taxDetails_taxYeardropdown">
    </mm-select-dropdown-control>
    <mm-select-dropdown-control *ngIf="isFromCreateTransaction" class="irs-tax-dropdown" [parentForm]="parentForm" [selectModel]="taxMonthDropDown" [isIrsDropdown]="true"
      id="taxDetails_taxMonthdropdown" data-testid="taxDetails_taxMonthdropdown">
    </mm-select-dropdown-control>
  </div>
  <hr class="bottom-divider">
</div>
